import { useCampaigns } from '../hooks';
import { campaignStatuses } from '../data';
import { Form, FormItem, TopPanel } from '../../components';
import { SearchBar, Dropdown, Table } from '../../components';
import type { CampaignItemType } from '../hooks';
import type { ColumnType, ButtonProps } from '../../components';

type CampaignsListTemplateProps = {
  buttons?: ButtonProps[];
  columns: ColumnType<CampaignItemType>[];
  listResult: ReturnType<typeof useCampaigns>;
};

const CampaignsListTemplate: React.FC<CampaignsListTemplateProps> = ({
  buttons,
  columns,
  listResult,
}) => {
  const { nodes, initializing, filters, setFilters, sort, setSort } =
    listResult;

  return (
    <div className="flex flex-col gap-y-md w-full">
      <Form<NonNullable<typeof filters>>
        initialValue={filters}
        onChange={setFilters}
      >
        <TopPanel
          buttons={buttons}
          buttonsLeftContent={
            <FormItem<NonNullable<typeof filters>> name="status" label="">
              <Dropdown
                placeholder="Status"
                grow={false}
                options={[
                  { value: '', label: 'All Statuses' },
                  ...campaignStatuses,
                ]}
              />
            </FormItem>
          }
          topLeftContent={
            <FormItem<NonNullable<typeof filters>> name="search" label="">
              <SearchBar />
            </FormItem>
          }
        />
      </Form>
      <div className="flex-1 overflow-y-auto">
        <Table
          data={nodes}
          loading={initializing}
          sort={sort}
          onSort={setSort}
          config={{ columns: columns }}
        />
      </div>
    </div>
  );
};

export default CampaignsListTemplate;
